// experience-backend has no cause-archival endpoints yet; honest no-ops.
const addHiddenDefaultCause = async ({ causeId, userId }) => {
  console.warn(
    "archieveCause: addHiddenDefaultCause is not supported by experience-backend yet.",
    { causeId, userId }
  );
};

const archiveCauseType = async (id) => {
  console.warn(
    "archieveCause: archiveCauseType is not supported by experience-backend yet.",
    { id }
  );
};

const archieveCause = async (id, userId) => {
  try {
    if (!id) throw new Error("No ID provided for archival");

    if (userId === "*") {
      hideDefaultCause(id, userId, userId);
      return;
    }

    await archiveCauseType(id);
  } catch (error) {
    console.error("[archiveCause] Error archiving cause:", error);
  }
};

export const hideDefaultCause = async (causeId, userId) => {
  try {
    if (!causeId || !userId) throw new Error("Missing causeId or userId");

    await addHiddenDefaultCause({
      causeId,
      userId,
    });
  } catch (error) {
    console.error("[hideDefaultCause] Error hiding cause:", error);
  }
};

export default archieveCause;
